import { CommonModule } from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { IngredientFilterComponent } from './ingredient-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DropdownModule,
  TriStateCheckboxModule,
} from 'primeng/primeng';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    TriStateCheckboxModule
  ],
  declarations: [IngredientFilterComponent],
  exports: [
    IngredientFilterComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IngredientFilterModule { }



// WEBPACK FOOTER //
// ./src/app/ingredient-filter/ingredient-filter.module.ts